
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"applicationFormDevelopmentalHistoryFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"applicationFormDevelopmentalHistory"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"crawled_years"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"crawled_months"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"crept_years"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"crept_months"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"walked_years"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"walked_months"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"toilet_trained_years"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"toilet_trained_months"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"first_word_years"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"first_word_months"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"use_of_couplets_years"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"use_of_couplets_months"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"word_phrases_years"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"word_phrases_months"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sentences_years"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sentences_months"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"conversational_language_years"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"conversational_language_months"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"read_years"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"read_months"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enjoy_watching_tv"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enjoy_watching_tv_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enjoy_being_read_to"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enjoy_being_read_to_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enjoy_reading_books"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enjoy_reading_books_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"speech_problems"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fine_motor_problems"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gross_motor_problems"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bed_wet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"current_list_chores"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"free_time_activities"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"play_independently"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"play_independently_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enjoy_video_games"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enjoy_video_games_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enjoy_playing_tablet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enjoy_playing_tablet_amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"play_phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"play_phone_amount"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":953}};
    doc.loc.source = {"body":"fragment applicationFormDevelopmentalHistoryFields on applicationFormDevelopmentalHistory {\n  form_id\n  crawled_years\n  crawled_months\n  crept_years\n  crept_months\n  walked_years\n  walked_months\n  toilet_trained_years\n  toilet_trained_months\n  first_word_years\n  first_word_months\n  use_of_couplets_years\n  use_of_couplets_months\n  word_phrases_years\n  word_phrases_months\n  sentences_years\n  sentences_months\n  conversational_language_years\n  conversational_language_months\n  read_years\n  read_months\n  enjoy_watching_tv\n  enjoy_watching_tv_amount\n  enjoy_being_read_to\n  enjoy_being_read_to_amount\n  enjoy_reading_books\n  enjoy_reading_books_amount\n  speech_problems\n  fine_motor_problems\n  gross_motor_problems\n  bed_wet\n  current_list_chores\n  free_time_activities\n  play_independently\n  play_independently_amount\n  enjoy_video_games\n  enjoy_video_games_amount\n  enjoy_playing_tablet\n  enjoy_playing_tablet_amount\n  play_phone\n  play_phone_amount\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["applicationFormDevelopmentalHistoryFields"] = oneQuery(doc, "applicationFormDevelopmentalHistoryFields");
        
